import { FC } from 'react';

import SectionCard from 'components/SectionCard';

type UnitTransferScheme = {
  id: string;
  schemeName: string;
  isin?: string | null;
  numberOfUnits: number;
  investmentAmount: number;
};

const SchemesTable: FC<{ schemes: UnitTransferScheme[] }> = ({ schemes }) => (
  <SectionCard
    title="Annexure 1 — Schemes"
    subTitle="Schemes the investor chose to transfer, snapshotted when the request was created"
    bodyClassName="px-4 py-3 sm:p-4 overflow-x-auto"
  >
    <table className="min-w-full divide-y divide-gray-200 text-sm">
      <thead>
        <tr className="text-left text-gray-500">
          <th className="py-2 pr-4">Scheme</th>
          <th className="py-2 pr-4">ISIN</th>
          <th className="py-2 pr-4 text-right">Units</th>
          <th className="py-2 pr-4 text-right">Investment Amount</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-100">
        {schemes.map(scheme => (
          <tr key={scheme.id}>
            <td className="py-2 pr-4">{scheme.schemeName}</td>
            <td className="py-2 pr-4">{scheme.isin || '-'}</td>
            <td className="py-2 pr-4 text-right">{scheme.numberOfUnits.toLocaleString('en-IN')}</td>
            <td className="py-2 pr-4 text-right">
              ₹ {scheme.investmentAmount.toLocaleString('en-IN')}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </SectionCard>
);

export default SchemesTable;
